import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { noop } from "lodash";
import Modal from "../../../../components/Modal";
import Form from "./Form";
import { useTime } from "../../../../utils/hooks/time";
import { useCompanyTimeFormat } from "../../../../utils/hooks/company";
import { useShiftAction } from "../store";
import { dateTimeFormat } from "../../../../utils/helpers/date";
import { useGeofencePunchGates } from "../../../../utils/hooks/useGeofencePunchGates";

function ClockModal({ setRefetchTimesheet = noop, openErrorModal }) {
    const { t } = useTranslation();
    const time = useTime();
    const timeFormat = useCompanyTimeFormat();

    const [shiftAction, { setShiftAction }] = useShiftAction();
    const { mustAcceptConsent } = useGeofencePunchGates();

    const title = useMemo(() => (
        <h3>
            {t("current-time")}:{' '}
            <span className='text-info'>
                {dateTimeFormat(time, timeFormat)}
            </span>
        </h3>
    ), [t, time, timeFormat]);

    const isOpen = useMemo(() => {
        return !mustAcceptConsent && ["start-shift", "start-new-shift", "start-break", "end-break", "switch"].includes(shiftAction);
    }, [mustAcceptConsent, shiftAction]);

    return (
        <Modal
            className='modal-dialog-centered'
            title={title}
            isOpen={isOpen}
            toggle={() => setShiftAction(null)}
        >
            <Form setRefetchTimesheet={setRefetchTimesheet} openErrorModal={openErrorModal} />
        </Modal>
    );
}

export default ClockModal;
